import React from 'react';
import PropTypes from 'prop-types';
import ReactTableDnDBody from './ReactTableDnDBody';

const ReactTableDefaultBody = ({
  page,
  getTableBodyProps,
  prepareRow,
  onRowClick,
}) => {
  // Função para determinar a cor da linha baseada na prioridade
  const getRowColor = (row) => {
    const coleta = row.original.coleta === 'Sim';
    const negociacao = row.original.negociacao === 'Sim';
    const vazio = row.original.vazio === 'Sim';

    // Prioridade: Coleta > Negociação > Vazio
    if (coleta) {
      return '#e8f5e8'; // Verde opaco
    } else if (negociacao) {
      return '#fff3e0'; // Laranja opaco
    } else if (vazio) {
      return '#fffde7'; // Amarelo opaco
    }

    return 'transparent'; // Sem cor
  };

  return (
    <tbody {...getTableBodyProps()}>
      {page.map(row => {
        prepareRow(row);
        const rowColor = getRowColor(row);

        return (
          <tr
            key={row.id || row.index}
            {...row.getRowProps()}
            style={{
              cursor: onRowClick ? 'pointer' : 'default',
              transition: 'background-color 0.2s ease',
              backgroundColor: rowColor
            }}
            onClick={onRowClick ? () => onRowClick(row.original) : undefined}
            onMouseEnter={onRowClick ? (e) => {
              const currentColor = e.currentTarget.style.backgroundColor;
              if (currentColor === 'transparent' || currentColor === '') {
                e.currentTarget.style.backgroundColor = '#f8f9fa';
              } else {
                // Escurecer a cor atual para o hover
                e.currentTarget.style.filter = 'brightness(0.95)';
              }
            } : undefined}
            onMouseLeave={onRowClick ? (e) => {
              e.currentTarget.style.backgroundColor = rowColor;
              e.currentTarget.style.filter = 'none';
            } : undefined}
          >
            {row.cells.map(cell => (
              <td
                key={cell.column.id}
                {...cell.getCellProps()}
              >
                {cell.render('Cell')}
              </td>
            ))}
          </tr>
        );
      })}
    </tbody>
  );
};

ReactTableDefaultBody.propTypes = {
  page: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  getTableBodyProps: PropTypes.func.isRequired,
  prepareRow: PropTypes.func.isRequired,
  onRowClick: PropTypes.func,
};

const ReactTableBody = ({
  page,
  getTableBodyProps,
  prepareRow,
  withDragAndDrop,
  updateDraggableData,
  theme,
  onRowClick,
}) => (
  withDragAndDrop ? (
    <ReactTableDnDBody
      page={page}
      getTableBodyProps={getTableBodyProps}
      prepareRow={prepareRow}
      updateDraggableData={updateDraggableData}
      theme={theme}
    />
  ) : (
    <ReactTableDefaultBody
      page={page}
      getTableBodyProps={getTableBodyProps}
      prepareRow={prepareRow}
      onRowClick={onRowClick}
    />
  )
);

ReactTableBody.propTypes = {
  page: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  getTableBodyProps: PropTypes.func.isRequired,
  prepareRow: PropTypes.func.isRequired,
  updateDraggableData: PropTypes.func.isRequired,
  withDragAndDrop: PropTypes.bool.isRequired,
  theme: PropTypes.shape({
    className: PropTypes.string,
  }),
  onRowClick: PropTypes.func,
};

ReactTableBody.defaultProps = {
  theme: { className: 'light' },
};

export default ReactTableBody;
